import { createContext, useContext, useEffect, useState } from "react"
import { getSession, signIn as signInRequest, signOut as signOutRequest } from "~/apis/auth"

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [ user, setUser ] = useState(null)
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    getSession()
      .then(({ user }) => setUser(user))
      .finally(() => setLoading(false))
  }, [])

  async function signIn(emailAddress, password) {
    const { user } = await signInRequest(emailAddress, password)
    setUser(user)
  }

  async function signOut() {
    await signOutRequest()
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
